import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  .MuiTableBody-root {
    background-color: ${({ theme }) => theme.neutral.white};
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[700]};
    padding: 12px 16px;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;
export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: theme.neutral.black,
    },
    "&:disabled svg": {
      color: theme.neutral.gray[500],
    },
  },
  delete: {
    color: theme.status.error,
  },
  buttonActive: {
    background: theme.button.primary,
    color: "white",
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
  closeModalResumeAnswer: {},
}));
